module.exports = __webpack_public_path__ + "static/media/f1TenthLiDARLogo.12052b17.png";